import { BrowserRouter } from "react-router-dom";
import ReactDOM from "react-dom";
import { I18nextProvider } from "react-i18next";
import { Suspense } from "react";

import Router from "./router";
import i18n from "./translation";
import { CurrencyProvider } from "./contexts/CurrencyContext";
import { MetalPriceProvider } from "./contexts/MetalPriceContext";

const Loading = () => (
  <div
    style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "100dvh",
      fontFamily: "Oswald, sans-serif",
      fontSize: "20px",
      backgroundColor: "#0F172A",
      color: "#FFFFFF",
      textTransform: "uppercase",
    }}
  >
    Loading Desk...
  </div>
);

const App = () => (
  <BrowserRouter>
    <I18nextProvider i18n={i18n}>
      <CurrencyProvider>
        <MetalPriceProvider>
          <Suspense fallback={<Loading />}>
            <Router />
          </Suspense>
        </MetalPriceProvider>
      </CurrencyProvider>
    </I18nextProvider>
  </BrowserRouter>
);

ReactDOM.render(<App />, document.getElementById("root"));
